<template>
  <div class="liff-staff-list">

    <div class="liff-staff-list__content" :class="{ 'need-bottom': !!branchId }">
      <ShopSelection ref="shopSelection" v-model="branchId" v-if="reservationBranchProvider"
        @setBranchModel="setSelectedBranch" :branch-provider="reservationBranchProvider"
        :show-branch-code="branchCodeIsShown" :placeholder="displayPlaceholder" :disabled="!configurationIsValid" />


      <div class="py-3" v-if="Object.keys(selectedBranch).length !== 0 && branchId">
        <div class="branch__title">{{ selectedBranch.name }}</div>

        <template v-if="displayBranchDetail">
          <div class="position-relative">

            <span class="branch__section__toggle" ><i class="mdi mdi-chevron-down mdi-24px" :class="{ 'mdi-rotate-180': isBranchDetailOpen }"></i></span>

            <div v-for="(group, idx) in isBranchDetailOpen ? branchDetailMapping : branchDetailMapping.slice(0, 1)" :key="idx"
              class="branch__section mt-3">
              <div class="branch__section__wrapper">
                <div v-for="(field, idx2) in isBranchDetailOpen ? group : group.slice(0, group[0].col_span?1:2)" :key="idx2"
                  class="branch__section__item d-flex flex-row align-items-start" :class="field.col_span"
                  @click="(idx==0 && (group[0].col_span?[0]:[0,1]).includes(idx2)) ? isBranchDetailOpen = !isBranchDetailOpen : null">
                  <div class="d-flex flex-column flex-fill">
                    <div class="branch__section__title">{{ field.title }}</div>
                    <div class="branch__section__value">
                      {{ selectedBranch[field.matched_key] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>


        <div v-if="displayBranchImages" class="branch__images mt-3">
          <b-carousel v-model="slide" :interval="0" :indicators="selectedBranch.images.length > 1" :no-wrap="true"
            class="branch__images__carousel mb-4">
            <b-carousel-slide v-for="img in selectedBranch.images" :key="img.id">
              <template #img>
                <img class="d-block img-fluid w-100" :src="img.url">
              </template>
            </b-carousel-slide>
          </b-carousel>

          <button v-if="selectedBranch.images.length > 1" :disabled="slide === 0" href="#" role="button"
            class="carousel-control-prev" @click="slide--">
            <span class="carousel-control-prev-icon"></span>
            <span class="sr-only">Next slide</span>
          </button>
          <button v-if="selectedBranch.images.length > 1" :disabled="slide === selectedBranch.images.length - 1"
            href="#" role="button" class="carousel-control-next" @click="slide++">
            <span class="carousel-control-next-icon"></span>
            <span class="sr-only">Next slide</span>
          </button>

        </div>
      </div>
    </div>

    <div class="wizard-mode-layout__footer-navigation">
      <div class="wizard-mode-layout__footer-button-wrapper">
        <button
          class="s-btn s-liff-theme-btn-outline s-btn-sm"
          type="button"
          @click="handleNegativeButtonClicked"
          v-if="hasPreviousStep()"
        >
          上一步
        </button>
        <button
          class="s-btn s-liff-theme-btn s-btn-sm"
          type="button"
          :disabled="!branchId || !configurationIsValid"
          @click="handlePositiveButtonClicked"
        >
          {{ textForProceedButton() }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import ShopSelection from "@/components/Page/Liff/Branch/ShopSelection";
import BookingPreset from '@/models/BookingPreset.model'
import _ from 'lodash';
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    ShopSelection,
  },
  inject: ['back', 'proceed', 'hasPreviousStep', 'textForProceedButton'],
  data() {
    return {
      branchId: null,
      selectedBranch: {},
      isBranchDetailOpen: true,
      slide: 0,
    }
  },
  computed: {
    ...mapState('liffBookingWizard', ['bookingPreset', 'configurationIsValid']),
    dataModel() {
      return new BookingPreset(this.bookingPreset)
    },
    branchDetailMapping() {
      return _.get(this.bookingPreset, 'config.branch_detail_mapping', false);
    },
    branchCodeIsShown() {
      return _.get(this.bookingPreset, 'config.show_branch_code', false);
    },
    displayBranchDetail() {
      return _.get(this.bookingPreset, 'config.display_branch_detail', false);
    },
    displayBranchImages() {
      return _.get(this.bookingPreset, 'config.display_branch_images', false);
    },
    branchField() {
      return _.get(this.bookingPreset, 'config.fields', []).find((field) => field._id == this.dataModel.branchFieldId)
    },
    reservationBranchProvider() {
      return this.branchField?.branch_provider
    },
    displayPlaceholder() {
      const placeholder = this.branchField?.default_select_text
      return ['', null, 'null'].includes(placeholder) ? '請選擇區域櫃點' : placeholder
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('liffBookingWizard', ['fetchBookingPreset', 'selectBranch']),
    async fetchBranches() {
      try {
        await this.$refs.shopSelection.fetchBranchesOptions();
      } catch (e) {
        if (!this.reservationBranchProvider) {
          this.$swal("請設定分店提供者", "", "warning");
        } else {
          console.error(e)
        }
      }
    },
    async init() {
      await this.fetchBookingPreset({ bookingPresetId: this.$route.params.bookingPresetId })
      this.$nextTick(this.fetchBranches)
    },
    setSelectedBranch(value) {
      this.selectedBranch = value

      this.selectBranch({
        id: this.branchId,
        name: this.selectedBranch.name,
      })
    },
    handleNegativeButtonClicked() {
      this.back()
    },
    handlePositiveButtonClicked() {
      this.proceed()
    },
  }
}
</script>

<style lang="scss" scoped>
.liff-staff-list {
  &__checkbox {
    display: none;
  }

  &__content {
    display: flex;
    flex-direction: column;

    &.need-bottom {
      margin-bottom: 150px;
    }

    &-item {
      display: flex;
      align-items: center;
      border: 1px solid #E5E5EA;
      border-radius: 10px;
      padding: 12px;
      color: #2C2C2E;
      font-size: 18px;
      font-weight: 500;
      gap: 12px;
      cursor: pointer;
      position: relative;

      &:hover {
        background-color: #F5F5F5;
      }

      &.active {
        border: 2px solid var(--s-primary);
      }

      &-img {
        width: 80px;
        height: 80px;
        border-radius: 50px;
        flex-shrink: 0;
      }

      &-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        gap: 12px;
      }

      &-check {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 32px;
        height: 32px;
        padding: 4px;
      }
    }
  }
}

.branch {
  &__title {
    font-size: 22px;
    font-weight: bold;
    color: black;
    text-align: center;
  }

  &__section {
    background: #ffffff;
    margin-bottom: 1px;
    border-radius: 10px;
    border: solid 1px #e5e5ea;
    padding: 2px;

    &__row {
      display: flex;

      &:not(:last-of-type) {
        margin-bottom: 20px;
      }
    }

    &__wrapper {
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
    }

    &__item {
      border-right: solid 1px #e5e5ea;
      border-bottom: solid 1px #e5e5ea;
      min-width: 50%;
      flex: 1 1 auto;
      margin: 0 -1px -1px 0;
      padding: 6px 10px;

      &.full {
        width: 100%;
      }
    }

    &__title {
      font-weight: 400;
      font-size: 14px;
      color: #636366;
    }

    &__value {
      font-size: 16px;
      color: #2c2c2e;
      white-space: pre-line;
    }

    &__value--empty {
      font-weight: 400;
      font-size: 16px;
      color: #b7b7b7;
    }

    &__toggle {
      position: absolute;
      top: 0;
      right: 0;
      padding: 4px;
    }

    .is-flex & {
      margin-bottom: 8px;
    }

    &.branch_title_section {
      border: none;
      padding: 0;

      .section__item {
        border: none;
        padding: 0;
      }

      .section__value {
        font-size: 22px;
        font-weight: bold;
        color: black;
        text-align: center;
      }
    }

    &.branch_subtitle_section {
      border: none;
      padding: 0;

      .section__item {
        border: none;
        padding: 0;
      }

      .section__value {
        font-size: 20px;
        color: black;
        text-align: center;
      }
    }
  }

  ::v-deep &__images {
    position: relative;

    .carousel {
      overflow: hidden;
      border-radius: 10px;
    }

    .carousel-caption {
      top: 0;
      width: 100%;
      left: 0;
      right: 0;
    }

    .carousel-item {
      margin-right: -100% !important;
    }

    .carousel-control-prev,
    .carousel-control-next {
      position: absolute;
      z-index: 10;
      padding: 5px !important;
      width: auto;
      box-shadow: 0px 4px 4px rgba(44, 44, 46, 0.15);
      background: #ffffff;
      border: 1px solid #e5e5ea;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.15);
      border-radius: 50%;
      top: 55%;
      bottom: auto;
      opacity: 1;
      transform: translateY(-50%);

      &:disabled {
        opacity: 0.3;
        cursor: not-allowed;
      }
    }

    .carousel-control-prev {
      left: -8px;
    }

    .carousel-control-next {
      right: -8px;
    }

    .carousel-control-next-icon {
      transform: translateX(1px);
      background-image: url("data:image/svg+xml,%3Csvg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M8.69434 7.99707C8.69434 8.22559 8.60645 8.43652 8.43066 8.6123L1.87402 15.0195C1.71582 15.1777 1.51367 15.2656 1.28516 15.2656C0.819336 15.2656 0.458984 14.9053 0.458984 14.4307C0.458984 14.2021 0.546875 14 0.696289 13.8418L6.68164 7.99707L0.696289 2.14355C0.546875 1.99414 0.458984 1.7832 0.458984 1.55469C0.458984 1.08887 0.819336 0.728516 1.28516 0.728516C1.51367 0.728516 1.71582 0.816406 1.87402 0.974609L8.43066 7.38184C8.60645 7.55762 8.69434 7.75977 8.69434 7.99707Z' fill='black'/%3E%3C/svg%3E%0A");
      background-size: 9px 16px;
    }

    .carousel-control-prev-icon {
      transform: translateX(-1px);
      background-image: url("data:image/svg+xml,%3Csvg width='9' height='16' viewBox='0 0 9 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.305664 7.99707C0.305664 7.75977 0.402344 7.55762 0.578125 7.38184L7.13477 0.974609C7.28418 0.816406 7.48633 0.728516 7.71484 0.728516C8.18945 0.728516 8.5498 1.08887 8.5498 1.55469C8.5498 1.7832 8.45312 1.99414 8.30371 2.14355L2.31836 7.99707L8.30371 13.8418C8.45312 14 8.5498 14.2021 8.5498 14.4307C8.5498 14.9053 8.18945 15.2656 7.71484 15.2656C7.48633 15.2656 7.28418 15.1777 7.13477 15.0195L0.578125 8.6123C0.402344 8.43652 0.305664 8.22559 0.305664 7.99707Z' fill='black'/%3E%3C/svg%3E%0A");
      background-size: 9px 16px;
    }

    .carousel-indicators {
      overflow: auto;

      >li {
        flex-shrink: 0;
        width: 10px;
        height: 10px;
        background-color: var(--s-primary);
        border-radius: 100%;
      }
    }
  }

}
</style>
